import { z } from 'zod';

/** Zod Schemas to assist with runtime security */
export const AmplifyRecord = z.object({
  /** The last updated date of the record */
  updatedAt: z
    .string()
    .datetime()
    .default(() => new Date().toISOString()), // Default to now

  /** The created date of the record */
  createdAt: z
    .string()
    .datetime()
    .default(() => new Date().toISOString()), // Default to now
});

/** Function for  */
export const createBaseRecordData = () => ({
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),
});

export const createAmplifyRecord = <T>(
  data: T
): T & z.infer<typeof AmplifyRecord> => ({
  ...data,
  ...createBaseRecordData(),
});

export const amplify_mutate_omit_fields: { [key: string]: true } = {
  updatedAt: true,
  createdAt: true,
  owner: true,
  __typename: true,
};
